/*
 * @Descripttion: file content
 * @Author: zc
 * @Date: 2020-05-26 13:24:22
 * @LastEditors: zc
 * @LastEditTime: 2023-11-24 16:59:06
 */
var env = process.env;
module.exports = {
  baseUrl: env.VUE_APP_BASE_URL,
  //接口请求默认url
  mcesBaseUrl: env.VUE_APP_MCES_BASE_URL,
  // 综评接口请求默认url
  emesBaseUrl: env.VUE_APP_EMES_BASE_URL,
  menhuBaseUrl: env.VUE_APP_MENHU_BASE_URL,
  mcesUrl: env.VUE_APP_MCES_URL,
  //综评访问地址url
  emesUrl: env.VUE_APP_EMES_URL,
  //测评访问地址url
  ediUrl: env.VUE_APP_EDI_URL,
  // EDI访问地址url
  eiUrl: env.VUE_APP_EI_URL,
  // EI访问地址url
  sycpUrl: env.VUE_APP_SYCP_URL,
  // 素养测评访问地址url
  znUrl: env.VUE_APP_ZN_URL,
  // 门户访问地址url
  title: env.VUE_APP_TITLE,
  //页面默认title
  tokenKey: 'yt-token' //token的缓存key

};